const Accounts = {
    btc: 'bc1qwnfdg0ku39fn44mn9jgu4nvn2zf92qwchx5ggz',
    sol: '3mwCC2dyKPjTfpbvMtYVwdNabaWV2huubGJxaiLGCuU8',
    // ftm: '0x60ecf32bC2019E0F21E65d3dB806908bC421bf23',
    nsa: '3mwCC2dyKPjTfpbvMtYVwdNabaWV2huubGJxaiLGCuU8',
  };

export default Accounts;